module.exports = __webpack_public_path__ + "img/82.3a7e8dd3.jpg";